/* eslint-disable consistent-return */
/* eslint-disable object-shorthand */
/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-template */
/* eslint-disable import/prefer-default-export */

import HelperS from '@/shared-modules/services/helper.service';

// =================== Кастомные директивы ===================

// =================== Директива проверки события @click вне элемента ===================
// Директива для проверки - был ли совершен @click за пределами текущего элемента или его детей
// Example: <someElem v-click-outside="clickOutsideHandler()"></someElem>

export function clickOutsideDirective() {
  return {
    inserted(el, binding) {
      el.clickOutsideEvent = (event) => {
        if (
          !(el === event.target || el.contains(event.target)) &&
          event.target.nodeName !== 'BUTTON'
        ) {
          binding.value(event);
        }
      };
      // setTimeout нужен для учета асинхронной подгрузки любого элемента на котором висит эта директива
      // Объяснение: яркий пример - это GfCustomTextEditor на странице "Изменения" в "Запросы на слияние" в "Проект"
      // На странице выше мы вызываем GfCustomTextEditor с помощью нажатия на кнопку, закрепленной за строкой в файле
      // Директива всегда отрабатывает раньше чем любой скрипт из Vue-компонентов поэтому в момент нажатия на кнопку, которая должна
      // подгрузить GfCustomTextEditor на страницу сразу же отрабатывает директива и пытается удалить элемент со страницы которого нет
      // Соответственно вылетает ошибка и все ломается. Выход - добавить событие удаление элемента по клику вне этого элемента с задержкой!!!
      setTimeout(() => {
        document.body.addEventListener('mousedown', el.clickOutsideEvent);
      }, 50);
    },
    unbind(el) {
      document.body.removeEventListener('mousedown', el.clickOutsideEvent);
    }
  };
}

// =================== Директива обрезки текста ===================
export const truncateTextDirective = {
  bind(el, binding) {
    applyTruncate(el, binding);
    window.addEventListener('resize', () => applyTruncate(el, binding));
  },
  update(el, binding) {
    applyTruncate(el, binding);
  },
  unbind(el, binding) {
    window.removeEventListener('resize', () => applyTruncate(el, binding));
  }
};

function applyTruncate(el, binding) {
  const { mediaValue } = binding.value;
  const { originalText } = binding.value;

  // Если передано просто число, используем его как длину по умолчанию
  // В директиву можно передать просто число - тогда текст будет обрезаться всегда с учетом указанной длины
  let length = typeof mediaValue === 'number' ? mediaValue : 15;

  // Если передан объект с допустимой длиной для каждого брейкпоинта
  // Пример: <someElem v-truncate-text="{
  //  mediaValue {
  //    sm: 10,
  //    md: 20,
  //    lg: 30,
  //    xl: 40,
  //    base: 20 - базовое значение, которое вернется в случае отсутствия конкретного значения для конкретного брейкпоинта
  //  },
  //  originalText: String(someVal)
  // }"

  if (typeof mediaValue === 'object' && mediaValue !== null) {
    length = HelperS.getValueForCurrentMediaBreakPoint(mediaValue) || 15;
  }

  if (originalText.length > length) {
    el.innerText = originalText.substring(0, length) + '...';
  } else {
    el.innerText = originalText;
  }
}
